import styled from "styled-components";
import { Tabs } from 'antd';
import "antd/es/tabs/style/css";

export const TabsStyled = styled(Tabs)`
`;
